module.exports = __webpack_public_path__ + "assets/img/img-training-01.538fd395.jpg";